module.exports = __webpack_public_path__ + "static/img/companyBackground1.2b5604d2.png";